export const KAMBI_WAPI_NAVIGATE = "KAMBI_WAPI_NAVIGATE";

export const KAMBI_WAPI_LOGIN = "KAMBI_WAPI_LOGIN";
export const KAMBI_WAPI_LOGOUT = "KAMBI_WAPI_LOGOUT";

export const KAMBI_WAPI_ADD_OUTCOME = "KAMBI_WAPI_ADD_OUTCOME";
export const KAMBI_WAPI_REMOVE_OUTCOME = "KAMBI_WAPI_REMOVE_OUTCOME";

export const KAMBI_WAPI_ADD_OUTCOMES = "KAMBI_WAPI_ADD_OUTCOMES";

export const KAMBI_WAPI_ADD_PREPACK_OUTCOME = "KAMBI_WAPI_ADD_PREPACK_OUTCOME";
export const KAMBI_WAPI_REMOVE_PREPACK_OUTCOME = "KAMBI_WAPI_REMOVE_PREPACK_OUTCOME";

export const KAMBI_WAPI_UPDATE_COMBINATION_BET_STAKE =
    "KAMBI_WAPI_UPDATE_COMBINATION_BET_STAKE";

export const KAMBI_WAPI_FORCE_BETSLIP_SHOW = "KAMBI_WAPI_FORCE_BETSLIP_SHOW";
export const KAMBI_WAPI_FORCE_BETSLIP_HIDE = "KAMBI_WAPI_FORCE_BETSLIP_HIDE";

export const KAMBI_WAPI_PAGE_INFO = "KAMBI_WAPI_PAGE_INFO";

export const KAMBI_WAPI_BETSLIP_MAXIMIZED = "KAMBI_WAPI_BETSLIP_MAXIMIZED";

export type WapiNavigateAction = {
    type: typeof KAMBI_WAPI_NAVIGATE;
    path: string;
};

export type WapiLoginAction = {
    type: typeof KAMBI_WAPI_LOGIN;
    username: string;
    kambiAuthCode: string;
};

export type WapiLogoutAction = {
    type: typeof KAMBI_WAPI_LOGOUT;
};

export type WapiAddOutcomeAction = {
    type: typeof KAMBI_WAPI_ADD_OUTCOME;
    outcomeId: number;
    source?: string;
};

export type WapiRemoveOutcomeAction = {
    type: typeof KAMBI_WAPI_REMOVE_OUTCOME;
    outcomeId: number;
};

export type WapiAddOutcomesAction = {
    type: typeof KAMBI_WAPI_ADD_OUTCOMES;
    outcomeIds: number[];
    source?: string;
};

export type WapiAddPrepackOutcomeAction = {
    type: typeof KAMBI_WAPI_ADD_PREPACK_OUTCOME;
    outcomeId: number;
    source?: string;
};

export type WapiRemovePrepackOutcomeAction = {
    type: typeof KAMBI_WAPI_REMOVE_PREPACK_OUTCOME;
    outcomeId: number;
    source?: string;
};

export type WapiUpdateCombinationAction = {
    type: typeof KAMBI_WAPI_UPDATE_COMBINATION_BET_STAKE;
    stake: number;
    outcomeIds: number[];
};

export type WapiForceBetslipShowAction = {
    type: typeof KAMBI_WAPI_FORCE_BETSLIP_SHOW;
    hide?: boolean;
};

export type WapiPageInfoAction = {type: typeof KAMBI_WAPI_PAGE_INFO};

export type WapiBetslipMaximizedAction = {
    type: typeof KAMBI_WAPI_BETSLIP_MAXIMIZED;
    maximized: boolean;
};

export const wapiNavigate = (path: string): WapiNavigateAction => ({
    type: KAMBI_WAPI_NAVIGATE,
    path,
});

export const wapiLogin = (username: string, kambiAuthCode: string): WapiLoginAction => ({
    type: KAMBI_WAPI_LOGIN,
    username,
    kambiAuthCode,
});

export const wapiLogout = (): WapiLogoutAction => ({type: KAMBI_WAPI_LOGOUT});

export const wapiAddOutcome = (
    outcomeId: number,
    source?: string,
): WapiAddOutcomeAction => ({
    type: KAMBI_WAPI_ADD_OUTCOME,
    outcomeId,
    source,
});

export const wapiRemoveOutcome = (outcomeId: number): WapiRemoveOutcomeAction => ({
    type: KAMBI_WAPI_REMOVE_OUTCOME,
    outcomeId,
});

export const wapiAddOutcomes = (
    outcomeIds: number[],
    source?: string,
): WapiAddOutcomesAction => ({
    type: KAMBI_WAPI_ADD_OUTCOMES,
    outcomeIds,
    source,
});

export const wapiAddPrepackOutcome = (
    outcomeId: number,
    source?: string,
): WapiAddPrepackOutcomeAction => ({
    type: KAMBI_WAPI_ADD_PREPACK_OUTCOME,
    outcomeId,
    source,
});

export const wapiRemovePrepackOutcome = (
    outcomeId: number,
): WapiRemovePrepackOutcomeAction => ({
    type: KAMBI_WAPI_REMOVE_PREPACK_OUTCOME,
    outcomeId,
});

export const wapiForceBetslipShow = (hide?: boolean): WapiForceBetslipShowAction => ({
    type: KAMBI_WAPI_FORCE_BETSLIP_SHOW,
    hide,
});

export const wapiPageInfo = (): WapiPageInfoAction => ({type: KAMBI_WAPI_PAGE_INFO});

export const wapiBetslipMaximized = (
    maximized: WapiBetslipMaximizedAction["maximized"],
): WapiBetslipMaximizedAction => ({
    type: KAMBI_WAPI_BETSLIP_MAXIMIZED,
    maximized,
});
